import { ensureScriptLoaded } from "../utils";

const WistiaScriptHook = {
  mounted() {
    this.loadWistiaScript();
  },

  updated() {
    this.loadWistiaScript();
  },

  loadWistiaScript() {
    const wistiaId = this.el.dataset.wistiaId;

    ensureScriptLoaded({
      src: `https://fast.wistia.com/embed/medias/${wistiaId}.jsonp`,
      id: `wistia-media-${wistiaId}`,
    });

    ensureScriptLoaded({
      src: "https://fast.wistia.com/assets/external/E-v1.js",
      id: "wistia-api",
    });
  },
};

export default WistiaScriptHook;
